import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, renderSlot as _renderSlot, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative z-10"
}
const _hoisted_2 = {
  key: 1,
  class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
}
const _hoisted_3 = { class: "flex min-h-full items-end justify-center items-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_4 = { class: "flex items-start p-8 flex-col overflow-x-auto w-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close modal", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = { class: "text-4xl mr-4" }

import { computed } from "vue";
import { useDialogsStore } from "@/Store/useDialogsStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalContainer',
  props: {
    dialogId: {},
    outSideClosable: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const dialogsStore = useDialogsStore();

const isOpen = computed<boolean>(() => {
  return dialogsStore.dialogs[props.dialogId];
});

function close() {
  dialogsStore.closeAllModals();
}

return (_ctx: any,_cache: any) => {
  return (isOpen.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (props.outSideClosable)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity",
              onClick: close
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2)),
        _createElementVNode("div", {
          class: "fixed inset-0 z-10 overflow-y-auto",
          onClick: close
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "relative transform overflow-hidden text-left shadow-xl transition-all bg-gradient-to-b from-gray-900 to-gray-800 rounded-lg",
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  type: "button",
                  class: "text-gray-400 self-end bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(dialogsStore).closeAllModals && _unref(dialogsStore).closeAllModals(...args)))
                }, _hoisted_7),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _renderSlot(_ctx.$slots, "default")
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})